'use strict';

/**
 * @description 不支持存储对象
 * - 如果要存储对象，自行 stringify
 */
const session = {
  getSessionStorage: (key: string): any => sessionStorage.getItem(key),

  setSessionStorage: (key: string, value: any): void => {
    sessionStorage.setItem(key, value);
  },
};

export default session;
